import { CircleCheck, Copy } from "lucide-react";

const CASE_TYPE = {
  prior_auth: "Prior Authorization",
  benefits_investigation: "seeQer",
};

const CASE_TYPE_COLOR = {
  prior_auth: "green",
  benefits_investigation: "blue",
};

export const CaseSuccess = ({ publicId, caseType }) => {
  const workflow = CASE_TYPE[caseType];
  const color = CASE_TYPE_COLOR[caseType];

  return (
    <>
      <div className="d-flex flex-column justify-content-center align-items-center w-100 mt-8">
        <CircleCheck size={80} color={color} />

        <p className="display-6 fw-medium my-2">{workflow} submitted.</p>

        <div className="text-secondary bg-light border rounded font-monospace p-2">
          <p className="mb-0 text-muted">
            Case ID
            <small className="ms-2 fw-bold">{publicId}</small>
            <a className="copy text-muted btn-copy d-print-none" href="#" data-clipboard-text={publicId}>
              <Copy className="copy-icon" size={12} />
            </a>
          </p>
        </div>
      </div>
    </>
  );
};
